// frank
export const URL_PREFIX = process.env.NODE_ENV === 'development' ? '' : '//api.dazao.com';

// release
// export const URL_PREFIX = process.env.NODE_ENV === 'development' ? 'api.release.dazaokouyu.com' : '//api.dazao.com';
